var e = 0;

function n() {
  return ++e;
}

function t() {
  return n();
}

export { t as useId };